import { createFileRoute, type ErrorComponentProps } from "@tanstack/react-router";
import { CmsRouteView } from "@/components/cms/CmsRouteView";
import { publishedCmsPageQuery } from "@/lib/cms/queries";
import { canonicalUrl } from "@/lib/seo/site";

export const Route = createFileRoute("/shipping")({
  head: () => ({ meta: [
    { title: "Shipping Policy — CB16 Atelier" },
    { name: "description", content: "Delivery expectations, timelines and costs for CB16 orders." },
    { property: "og:title", content: "CB16 Shipping Policy" },
    { property: "og:description", content: "Delivery expectations, timelines and costs for CB16 orders." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { property: "og:url", content: canonicalUrl("/shipping") },
  ], links: [{ rel: "canonical", href: canonicalUrl("/shipping") }] }),
  loader: ({ context }) => context.queryClient.ensureQueryData(publishedCmsPageQuery("shipping")),
  errorComponent: ({ error }: ErrorComponentProps) => (
    <div role="alert" className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">
      {error instanceof Error ? error.message : "Something went wrong."}
    </div>
  ),
  notFoundComponent: () => (
    <div className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">Page not found.</div>
  ),
  component: () => <CmsRouteView slug="shipping" fallbackTitle="Shipping Policy" />,
});